<div class="eiq-loader mat-elevation-z4">
  <img class="eiq-loader__spinner" src="./assets/ui/eiq-loader.gif" />
  <span class="fs__md fw__500">
    @if (takingLongerInd$ | async) {
      Loading might take a bit longer than expected...
    } @else {
      Loading content, please wait...
    }
  </span>
</div>
